import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

const commonRoutes = [
	{
		path: '/login',
		type: 'login',
		component: () => import('@/views/login'),
	},
	{
		path: '/changePwd',
		type: 'syshome',
		component: () => import('@/views/changePwd'),
  },
];

const createRouter = () => new Router({
	linkActiveClass: 'active',
	routes: commonRoutes
});

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher 
}

export default router





// WEBPACK FOOTER //
// ./src/router/index.js